import React, { useState } from 'react';
import { Button, List } from 'semantic-ui-react';

const Integracao = ({ label, description, ativo, pendente, onClick, onCancel, children }) => {
  const [isOver, setIsOver] = useState(false);

  const onMouseOver = () => ativo && setIsOver(true);
  const onMouseOut = () => ativo && setIsOver(false);

  const getButtonLabel = () => {
    let result = 'Ativar';
    if (ativo) {
      result = isOver ? 'Desativar' : 'Ativo';
    } else if (pendente) {
      result = 'Confirmar';
    }
    return result;
  };

  return (
    <List.Item className="animated-list-item va-integ">
      <div className="va-integ-topo">
        <div className="va-integ-texto">
          <List.Header className="notification-header">{label}</List.Header>
          <List.Description style={{ fontSize: '1.05em', marginTop: 5 }}>{description}</List.Description>
        </div>
        <div className="va-integ-acoes">
          {pendente && (
            <Button
              onClick={onCancel}
              basic
              className="btn-ui-1-basic"
              size="large"
            >
              Cancelar
            </Button>
          )}
          <Button
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            onClick={onClick}
            positive={ativo && !isOver}
            negative={ativo && isOver}
            primary={!ativo && pendente}
            className={ativo || pendente ? '' : 'btn-ui-1'}
            size="large"
            style={{ width: 120 }}
          >
            {getButtonLabel()}
          </Button>
        </div>
      </div>
      {children && <div className="va-integ-corpo">{children}</div>}
    </List.Item>
  );
};

export default Integracao;
